import { render } from "./TestingOverview.vue?vue&type=template&id=89a79162&ts=true"
import script from "./TestingOverview.vue?vue&type=script&lang=ts"
export * from "./TestingOverview.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__